import React, { useEffect, useRef, useState } from "react";
import { Form, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { saveOtp, setToken } from "../../features/auth/authSlice";
import svg85 from "../../assets/svg/svg85.svg";
import ndovuHr from "../../assets/img/ndovuPayShield.png";
import axiosInstance from "../../instance";

function LoginOtp() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const { user, authLoading, loginInfo, saving } = useSelector(
    (state) => state.auth,
  );

  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const [isInputEmpty, setIsInputEmpty] = useState(true);

  const [verificationCode, setVerificationCode] = useState(["", "", "", ""]);

  const [counter, setCounter] = useState({ minutes: 0, seconds: 59 });

  const cancatenatedString = verificationCode?.join("");
  const onFinish = async (data) => {
    if (isInputEmpty || cancatenatedString.length !== 4) {
      toast.error("Please provide a valid 4-digit OTP");
      return;
    }

    if (!loginInfo?.usrId) {
      toast.error("User ID is missing. Please try logging in again.");
      navigate("/login");
      return;
    }

    const res = await dispatch(
      saveOtp({
        usrId: loginInfo?.usrId,
        usrCode: cancatenatedString,
        url: "usr/post_authenticate_user_otp.action",
      }),
    );

    if (res?.payload?.success) {
      await dispatch(setToken(res?.payload?.token));
      axiosInstance.defaults.headers.common["Authorization"] =
        await `${res?.payload?.token}`;

      toast.success(res?.payload?.messages?.message);

      setIsInputEmpty(true);
      setVerificationCode(["", "", "", ""]);
      form.resetFields();

      await navigate("/dashboard-main");
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    setIsInputEmpty(!value);
    if (value === "") {
      if (index > 0) {
        inputRefs[index - 1].current.focus();
      }
    } else if (index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }

    const updatedVerificationCode = [...verificationCode];
    updatedVerificationCode[index] = value;
    setVerificationCode(updatedVerificationCode);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").trim();
    const digits = pastedData.replace(/[^0-9]/g, "");

    if (digits.length >= 4) {
      const characters = digits.slice(0, 4).split("");
      setVerificationCode(characters);
      setIsInputEmpty(false);
      inputRefs[3].current.focus();
    } else {
      toast.error("Please paste a valid 4-digit OTP");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  async function handleResendOtp() {
    const res = await dispatch(
      saveOtp({
        url: "usr/resendLoginOtp.action",
        usrId: loginInfo?.usrId,
      }),
    );
    if (res?.payload?.success) {
      setCounter({ minutes: 0, seconds: 59 });
      await toast.success(res?.payload?.messages?.message);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (counter.minutes === 0 && counter.seconds === 0) {
        clearInterval(interval);
      } else {
        setCounter((prevCounter) => {
          if (prevCounter.seconds === 0) {
            return { minutes: prevCounter.minutes - 1, seconds: 59 };
          } else {
            return { ...prevCounter, seconds: prevCounter.seconds - 1 };
          }
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [counter, authLoading]);

  return (
    <div className="flex h-[100vh] w-full overflow-y-scroll font-dmSans">
      <div
        className={`w-[50%] h-screen lg:flex hidden justify-center items-center login-pic }`}
      ></div>
      <div className="bg-[#f4f5f7] lg:w-[50%] w-full flex flex-col justify-center items-center lg:px-[10%] px-3">
        <div className="image-container">
          <img
            loading="lazy"
            decoding="async"
            src={ndovuHr}
            alt="logo"
            className="w-[400px]  h-[250px] object-contain animated-image"
          />
        </div>
        <Form
          layout="vertical"
          ref={formRef}
          name="registration"
          onFinish={onFinish}
          scrollToFirstError
          form={form}
          className="lg:w-[30rem] w-full max-w-full"
        >
          <div className="mb-6 sm:mb-8 lg:mb-[2rem] flex flex-col items-center text-center text-[#333] ']">
            <div className="text-2xl sm:text-3xl lg:text-[2rem] font-[700] font-dmSans">
              Verify Account
            </div>
            <div className="mt-3 sm:mt-4 lg:mt-[1rem] text-sm sm:text-base lg:text-[1.125rem] font-[400] font-dmSans">
              Enter the 4 digit code sent to your phone or email
            </div>
          </div>
          <div className="flex items-center justify-center gap-[1.25rem] mt-[1rem] w-full">
            {inputRefs?.map((ref, index) => (
              <div key={index}>
                <input
                  ref={ref}
                  className="otp-input"
                  type="text"
                  maxLength="1"
                  value={verificationCode[index]}
                  onChange={(e) => handleInputChange(e, index)}
                  onPaste={handlePaste}
                />
              </div>
            ))}
          </div>

          <div className="my-[3.81rem]">
            <button disabled={saving} type="submit" className="cstm-btn">
              {saving ? <Spin /> : "Continue"}
            </button>
          </div>

          <div className=" w-full  mt-[1.91rem] justify-between  flex items-center">
            <div
              onClick={handleBack}
              className="text-xs sm:text-sm lg:text-[0.875rem] text-[#2F2B43] font-[400] flex items-center  cursor-pointer gap-[0.5rem] font-dmSans"
            >
              <img src={svg85} alt="svg85" className="" /> Back 
            </div>

            <div className="flex  text-[#2F2B43] font-dmSans text-[.875rem] font-[400]">
              {counter.minutes === 0 && counter.seconds === 0 ? (
                <button
                  disabled={saving}
                  className=" "
                  onClick={handleResendOtp}
                  type="button"
                >
                  Didn’t Recieve code?{" "}
                  <span className="underline cursor-pointer"> Resend</span>
                </button>
              ) : (
                <span className="label_3 !text-blu">
                  Resend in {counter.minutes.toString().padStart(2, "0")}:
                  {counter.seconds.toString().padStart(2, "0")}
                </span>
              )}
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default LoginOtp;
